import React from 'react'
import { Routes, Route } from "react-router-dom";

import About from './components/About/About';
import Products from './components/Products/Products';
import Gallary from './components/Gallary/Gallary';
import Contact from './components/Contact/Contact';
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";

export default function App() {
  return (
    <div>
    
     <div>
        <Navbar />
     <Routes>
       <Route path="/" element={<Home />} />
       <Route path="about" element={<About/>} />
       <Route path="products" element={<Products/>} />
       <Route path="gallery" element={<Gallary/>} />
       <Route path="contact" element={<Contact/>} />
     </Routes>
     <Footer/>
    </div>

    </div>
  );
}
